window.timeago = function (date) {
  const now = new Date();
  const min = (now - date) / 1000 / 60;

  if (min < 1) return 'just now';
  if (min < 60) return `${parseInt(min)} min ago`;
  if (min < 1440) return `${parseInt(min / 60)} hours ago`;
  if (min < 7200) // more than 5 days
  { return `${parseInt(min / 1440)} days ago`; }

  return date.toLocaleString('en-US');
};
